const CARD_BRAND_LABELS: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'American Express',
  discover: 'Discover',
}

export function cardLabel(
  brand: string | undefined,
  last4: string | undefined,
): string {
  const brandLabel = brand
    ? (CARD_BRAND_LABELS[brand.toLowerCase()] ?? brand.charAt(0).toUpperCase() + brand.slice(1))
    : null
  const name = brandLabel ? `${brandLabel} card` : 'card on file'
  return last4 ? `${name} ending in ${last4}` : name
}

export function formatCardExpiry(expMonth: number, expYear: number): string {
  return `${String(expMonth).padStart(2, '0')}/${expYear}`
}
